import { __extends } from "tslib";
import { SortIndicatorStyle_$type } from "./SortIndicatorStyle";
import { ColumnOptionsIconAlignment_$type } from "./ColumnOptionsIconAlignment";
import { ColumnOptionsIconBehavior_$type } from "./ColumnOptionsIconBehavior";
import { IgrTextCellInfo } from "./igr-text-cell-info";
import { TextHeaderCellModel as TextHeaderCellModel_internal } from "./TextHeaderCellModel";
import { ensureBool, ensureEnum, brushToString, stringToBrush } from "igniteui-react-core";
/**
 * Backing information for a text header cell.
*/
var IgrTextHeaderCellInfo = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrTextHeaderCellInfo, _super);
    function IgrTextHeaderCellInfo() {
        return _super.call(this) || this;
    }
    IgrTextHeaderCellInfo.prototype.createImplementation = function () {
        return new TextHeaderCellModel_internal();
    };
    Object.defineProperty(IgrTextHeaderCellInfo.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrTextHeaderCellInfo.prototype, "isColumnOptionsEnabled", {
        /**
         * Sets or gets whether the filter UI should be visible in the header.
        */
        get: function () {
            return this.i.lu;
        },
        set: function (v) {
            this.i.lu = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrTextHeaderCellInfo.prototype, "sortIndicatorStyle", {
        get: function () {
            return this.i.ls;
        },
        set: function (v) {
            this.i.ls = ensureEnum(SortIndicatorStyle_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrTextHeaderCellInfo.prototype, "columnOptionsIconAlignment", {
        /**
         * Gets or sets the alignment of the column options icon within the header cell.
        */
        get: function () {
            return this.i.lo;
        },
        set: function (v) {
            this.i.lo = ensureEnum(ColumnOptionsIconAlignment_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrTextHeaderCellInfo.prototype, "columnOptionsIconColor", {
        /**
         * Gets or sets the color for the column options icon in the header.
        */
        get: function () {
            return brushToString(this.i.l6);
        },
        set: function (v) {
            this.i.l6 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrTextHeaderCellInfo.prototype, "columnOptionsIconBehavior", {
        /**
         * Gets or sets how the column option icon will behave in the header.
        */
        get: function () {
            return this.i.lq;
        },
        set: function (v) {
            this.i.lq = ensureEnum(ColumnOptionsIconBehavior_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    return IgrTextHeaderCellInfo;
}(IgrTextCellInfo));
export { IgrTextHeaderCellInfo };
//# sourceMappingURL=igr-text-header-cell-info.js.map
